// src/config.js
const config = {
  // apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'http://localhost', // Default to localhost for development
  // apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'https://arxis.local', // Default to localhost for development
  apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'https://api.arxistechnologies.com', // Default to localhost for development
};

export default config;
